<template>
    <b-modal id="deleteModal" ref="modal" @hidden="hideDeleteModal" title=""
             header-class="header" body-class="body" footer-class="footer">
      <template #modal-header="{close}">
        <button type="button" aria-label="Close" class="close p-1" @click="close()">×</button>
      </template>
      <div class="custom-body w-100 d-flex align-items-center flex-column">
        <i class="fa fa-trash-o mb-2 delete-icon" aria-hidden="true"></i>
        このテンプレートを削除しますか？
      </div>
      <template #modal-footer>
        <div class="d-flex justify-content-center w-100">
          <button class="btn btn-danger rounded-0 btn-sm custom-delete text-center" @click="confirmDelete(modal_data.id)">
            削除
          </button>
        </div>
      </template>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: "DeleteModal",
    props: {
      modal_data: {
        id: String
      }
    },
    methods: {
      hideDeleteModal() {
        this.$emit("hide-modal");
      },
      confirmDelete(id) {
        this.$emit("confirm-delete", id);
      }
    },
    mounted() {
      this.$refs["modal"].show();
    }
  }
  </script>
  
  <style scoped>
  >>> .header {
    background: #fbfcff;
    border-bottom: none;
  }
  
  >>> .body {
    padding-bottom: 5px;
    padding-top: 5px;
  }
  
  >>> .footer {
    padding-top: 5px;
    border-top: none;
  }
  
  .custom-body {
    font-size: 16px;
  }
  
  .custom-delete {
    min-width: 0;
    font-size: 14px;
    padding: .30rem 1.6rem;
  }
  
  .delete-icon {
    font-size: 30px;
    height: 60px;
    width: 60px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: #e7e9f6;
    color: #036D6C;
    border-radius: 50%;
  }
  </style>